module.exports = __webpack_public_path__ + "img/4.187e0235.png";